import { useContext } from 'react';
import { NotificationsMessageContext } from "./NotificationsMessageContext";
export var useNotificationsMessage = function () {
    return useContext(NotificationsMessageContext);
};
